import { Fragment } from 'react';
import { Grid } from '@mui/material';
import OrderInfo from '../order/OrderInfo.component';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import dayjs from 'dayjs';
import InfoIcon from '@mui/icons-material/Info';
import ErrorIcon from '@mui/icons-material/Error';
import _ from 'lodash';

const AvatarStyle = {
  avatar: {
    sx: {
      color: '#005488',
      opacity: 0.9,
    },
  },
};

const CardInfoOperation = ({ list, isLoading, children, otherInfo = [] }) => {
  const requested_date = _.get(
    list,
    'id_operation_list.data.attributes.requested_date'
  );
  const requested_hour = _.get(
    list,
    'id_operation_list.data.attributes.requested_hour'
  );
  const hour_type = _.get(list, 'id_operation_list.data.attributes.hour_type');
  const hour =
    requested_hour || hour_type
      ? `${
          requested_hour
            ? `   ${dayjs(requested_hour, 'HH:mm:ss').format('HH:mm')}`
            : ''
        } ${hour_type ? hour_type : ''}`
      : '';
  return (
    <Fragment>
      {list && (
        <Grid container pt={3} spacing={2} alignItems={'center'}>
          <Grid
            item
            xs={12}
            md={children || _.isEmpty(list?.warning_notes) ? 12 : 8}
          >
            <OrderInfo
              isLoading={isLoading}
              data={[
                {
                  id: 'yacht_name',
                  value: `${
                    list?.id_operation_list?.data?.attributes?.id_yacht?.data
                      ?.attributes?.yacht_name
                  } #${
                    list?.id_operation_list?.data?.attributes?.id_yacht?.data
                      ?.id
                  }`,
                  icon: (
                    <DirectionsBoatIcon style={{ width: 16, height: 16 }} />
                  ),
                  sxTypography: {
                    fontSize: 17,
                  },
                  ...AvatarStyle,
                },
                {
                  id: 'date',
                  value: `${requested_date ? dayjs(requested_date).format('DD/MM/YYYY') : ''} ${hour}`,
                  icon: <CalendarMonthIcon style={{ width: 16, height: 16 }} />,
                  ...AvatarStyle,
                },

                {
                  id: 'location',
                  value:
                    list?.id_operation_list?.data?.attributes?.id_marina?.data
                      ?.attributes?.marina,
                  icon: <LocationOnIcon style={{ width: 16, height: 16 }} />,
                  ...AvatarStyle,
                },
                {
                  id: 'status_operation_booking',
                  value:
                    list?.id_operation_list?.data?.attributes
                      ?.status_operation_booking,
                  icon: <InfoIcon style={{ width: 16, height: 16 }} />,
                  ...AvatarStyle,
                },
                ...otherInfo,
              ]}
              height={50}
              backgroundColor={'#005488'}
            />
          </Grid>
          {children && (
            <Grid item xs={12} md={6}>
              {children}
            </Grid>
          )}
          {list?.warning_notes && (
            <Grid item xs={12} md={children ? 6 : 4}>
              <OrderInfo
                isLoading={isLoading}
                data={[
                  {
                    id: 'warning_notes',
                    value: list?.warning_notes,
                    sxTypography: {
                      fontSize: 15,
                    },
                  },
                ]}
                icon={ErrorIcon}
                height={50}
                backgroundColor={'rgb(216, 67, 21)'}
              />
            </Grid>
          )}
        </Grid>
      )}
    </Fragment>
  );
};

export default CardInfoOperation;
